import { fromUnixTime } from "date-fns/esm";

import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { TofuWorkspace } from "types/generated";
import { formatDateWithPattern } from "utils/date";

const StackWorkspacesLockedAtCell = ({
  item: workspace,
  ...cellProps
}: TableSimpleCellProps<TofuWorkspace>) => {
  const formattedDate =
    workspace.isLocked && workspace.createdAt
      ? formatDateWithPattern(fromUnixTime(workspace.createdAt), "MMM do, HH:mm:ss")
      : "-";

  return (
    <TableSimpleCell {...cellProps}>
      <TableCellText>{formattedDate}</TableCellText>
    </TableSimpleCell>
  );
};

export default StackWorkspacesLockedAtCell;
